import { render, staticRenderFns } from "./RecordDocumentEntry.vue?vue&type=template&id=2126f7b0&"
import script from "./RecordDocumentEntry.vue?vue&type=script&lang=js&"
export * from "./RecordDocumentEntry.vue?vue&type=script&lang=js&"
import style0 from "./RecordDocumentEntry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports